module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/afore34-e34cba83202565bf93e59f5bd04dbf83.jpg";